import React from 'react';

function Stats({ stats }) {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
        <div className="bg-slate-50 rounded-lg border border-slate-200 p-5">
          <div className="text-3xl font-bold text-purple-600">{stats.total}</div>
          <div className="text-sm text-slate-500 mt-1">Total Laws</div>
        </div>
        <div className="bg-slate-50 rounded-lg border border-slate-200 p-5">
          <div className="text-3xl font-bold text-green-600">{stats.active}</div>
          <div className="text-sm text-slate-500 mt-1">Active Laws</div>
        </div>
        <div className="bg-slate-50 rounded-lg border border-slate-200 p-5">
          <div className="text-3xl font-bold text-yellow-600">{stats.challenged}</div>
          <div className="text-sm text-slate-500 mt-1">Challenged</div>
        </div>
        <div className="bg-slate-50 rounded-lg border border-slate-200 p-5">
          <div className="text-3xl font-bold text-blue-600">{stats.pending}</div>
          <div className="text-sm text-slate-500 mt-1">Pending</div>
        </div>
        <div className="bg-slate-50 rounded-lg border border-slate-200 p-5">
          <div className="text-3xl font-bold text-red-600">{stats.blocked}</div>
          <div className="text-sm text-slate-500 mt-1">Blocked</div>
        </div>
      </div>
    </div>
  );
}

export default Stats;
